import React from "react";
import Select from "react-select";
import { FaPlus } from "react-icons/fa";

const CustomAutoComplete = ({
  placeholder = "Selecciona una opción...",
  value,
  onChange,
  options = [],
  valueKey = "id", // Clave para el valor de las opciones
  labelKey = "name", // Clave para el texto de las opciones
  label, // Etiqueta opcional
  isRequired = false, // Prop para determinar si el campo es requerido
  onAddNew, // Función para manejar la acción de agregar un nuevo elemento
  bg = "#F9FAFB",
  width = "100%",
}) => {
  // Formateamos las opciones usando los valores proporcionados
  const formattedOptions = options.map((option) => ({
    value: option[valueKey],
    label: option[labelKey],
  }));

  const handleChange = (selectedOption) => {
    onChange(selectedOption ? selectedOption.value : ""); // Actualiza solo el valor
  };

  return (
    <div className="poppins-medium flex flex-col space-y-1 tracking-wider relative">
      {label && (
        <label className="text-[#8F99A6] text-xs tracking-wider">
          {label}
          {isRequired && <span className="text-[#BF1F2E]">*</span>}
        </label>
      )}
      <div className="relative">
        <Select
          value={
            formattedOptions.find((option) => option.value === value) || null
          }
          isClearable={true}
          onChange={handleChange}
          options={formattedOptions}
          placeholder={placeholder}
          classNames={"poppins-regular"}
          components={{
            IndicatorSeparator: () => null, // Ocultar el separador
          }}
          noOptionsMessage={() => (
            <div
              className="flex items-center justify-between px-2 py-1 cursor-pointer"
              onClick={onAddNew} // Acción para agregar un nuevo elemento
            >
              <span className="text-gray-500 text-sm">Agregar</span>
              <FaPlus color="#C9C9C9" size={14} />
            </div>
          )}
          styles={{
            control: (base) => ({
              ...base,
              backgroundColor: bg,
              borderRadius: "9px",
              padding: "4px",
              fontSize: "10px",
              width: width,
              minHeight: "47px",
              boxShadow: "none",
              border: "none",
              "&:hover": {
                borderColor: "transparent",
              },
              "&:focus-within": {
                boxShadow: "0 0 0 2px rgba(66, 153, 225, 0.6)",
              },
            }),
            placeholder: (base) => ({
              ...base,
              color: "#C9C9C9",
            }),
            singleValue: (base) => ({
              ...base,
              color: "#4A5568",
            }),
            menu: (base) => ({
              ...base,
              zIndex: 10,
            }),
          }}
          className="poppins-regular text-[10px]"
        />
      </div>
    </div>
  );
};

export default CustomAutoComplete;
